export default __webpack_public_path__ + "static/illustration_caixa_preta_desktop-bb6521e88ab5f9e1e68cc66bb1b9f111.svg";